module.exports = __webpack_public_path__ + "static/img/045_TO8_1551.920addf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/045_TO8_1551.jpg
// module id = 4L8k
// module chunks = 0